import type { WorkspaceRole } from "@unbox/api";

const MIN_PORTFOLIO_MERCHANTS = 2;

type WorkspaceAccess = { role: WorkspaceRole; merchants: readonly unknown[] };

export type WorkspaceEntry = "workspace" | "portfolio";

export const hasWorkspacePortfolio = (workspace: Pick<WorkspaceAccess, "merchants">): boolean =>
  workspace.merchants.length >= MIN_PORTFOLIO_MERCHANTS;

export const workspaceEntry = (workspace: WorkspaceAccess): WorkspaceEntry | null => {
  if (workspace.role === "workspace_admin") return "workspace";
  return hasWorkspacePortfolio(workspace) ? "portfolio" : null;
};
